import './i18n'

import Toaster from 'features/common/components/Toaster/Toaster'
import {useAuth} from 'features/common/context/auth'

import './App.css'
import AuthorizedView from 'features/authorized'
import UnauthorizedView from 'features/unauthorized'

const App = () => {
    const {user} = useAuth()
    return (
        <>
            {user ? <AuthorizedView /> : <UnauthorizedView />}
            <Toaster />
        </>
    )
}

export default App
